// Types
import { SET_SIGNALS, ADD_SHOWN_SIGNAL, CLEAR_SIGNALS } from 'store/actions/Signals/types'

const initialState = {
  signals: [],
  shownSignals: new Set(),
}

const signalsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIGNALS:
      return {
        ...state,
        signals: action.payload,
      }
    case ADD_SHOWN_SIGNAL:
      return {
        ...state,
        shownSignals: new Set([...state.shownSignals, action.payload]),
      }
    case CLEAR_SIGNALS:
      return {
        ...state,
        signals: [],
        shownSignals: new Set(),
      }
    default:
      return state
  }
}

export default signalsReducer
